import { SuiteType } from '../../item.model';
import { AVAILABILITY_CONFIG } from './availability.config';
import { LEASE_CONFIG } from './lease.config';
import { TENANT_CONFIG } from './tenant.config';

export const DETAILS_MODAL_CONFIG = {
  [SuiteType.Availability]: AVAILABILITY_CONFIG,
  [SuiteType.Tenant]: TENANT_CONFIG,
  [SuiteType.Lease]: LEASE_CONFIG,
};
